<template>
  <v-content class="pb-0">
    <v-app-bar app color="#00339F" dense shrink-on-scroll
      fade-img-on-scroll>
    <v-row>
    <v-col cols="auto">
      <v-img
        class="my-auto"
        contain
        :src="require('@/assets/cliente11.jpg')"
        width="55"
        height="55"
      />
      </v-col>

      <p class="my-auto">
        <v-toolbar-title
          style="color: white"
          :class="[$vuetify.breakpoint.mdAndUp ? 'title' : 'subtitle-1']"
        >
          ASSA COMPAÑIA DE SEGUROS
        </v-toolbar-title>
      </p>

      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top right, rgba(127,159,244), rgba(10,73,244)"
        ></v-img>
      </template>
      </v-row>
    </v-app-bar>
  </v-content>
</template>

<script>
import { dbRefAppMovil } from "../main";
export default {
  data() {
    return {
      sideNav: false,
      itemsUbicGeo: [
        { title: "El Salvador", route: "/proveedoresElSalvador" },
        { title: "Guatemala", route: "/proveedoresGuatemala" },
        { title: "Honduras", route: "/proveedoresHonduras" },
        { title: "Nicaragua", route: "/proveedoresNicaragua" },
        { title: "Costa Rica", route: "/proveedoresCostaRica" },
        { title: "Panama", route: "/proveedoresPanama" }
      ],
      hidden: false,
      logueado: false
    };
  },
  created() {
    this.verificarAuth();
  },
  methods: {
    verificarAuth() {
      let me = this;
      dbRefAppMovil.auth().onAuthStateChanged(function(user) {
        if (user) {
          //console.log("si esta logueado Header");
          me.logueado = true;
        } else {
          //console.log("no esta logueado Header");
          me.logueado = false;
        }
      });
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
